import { guid } from "../system/utils";

const _getNextDay = rows => {
  return (
    Math.max(...rows.filter(t => t.day !== undefined).map(t => t.day), 0) + 1
  );
};

const _resortProgramList = list => {
  list.sort((a, b) => {
    return a.day < b.day ? -1 : 1;
  });
};

const changeDescription = (complexType, val) => {
  complexType.program.forEach(item => {
    if (item.isEdited) {
      item.description = val;
      item.isEdited = false;
    }
  });
};

const getProgramValueData = actionValue => {
  let prg = [];

  if (actionValue.props.value && actionValue.props.value.program) {
    actionValue.props.value.program.forEach(p => {
      prg.push({
        day: p.day,
        cities: p.cities,
        description: p.description,
        isEdited: false
      });
    });
  }

  return {
    program: prg
  };
};

const changeLanguage = (attributs, attrObject) => {
  let item = attributs.find(
    attr => attr.attributeId === attrObject.props.attributeId
  );

  if (item) {
    let value = item.value;
    let typeLower = item.attributeType.type.toLowerCase();

    if (value.id) {
      attrObject.props.value.id = value.id;
    } else {
      if (attrObject.props.value.id) {
        delete attrObject.props.value.id;
      }
    }

    attrObject.props.value[typeLower] = value[typeLower];
  }
};

const getInitState = (object, languages, attributeId) => {
  let result = {
    attributeId,
    program: [],
    attributeValueIdByLang: {}
  };

  // Из объекта получаем ранее заполненую программу в более простой структуре
  let objectUsedAttribute = object.data.map(o => {
    let result = {
      languageId: o.languageId,
      attributeValueId: undefined,
      program: []
    };

    let attributePreset = o.attributePreset.find(
      p => p.attributeId === attributeId
    );

    if (attributePreset) {
      result.attributeValueId = attributePreset.id;
      result.program = attributePreset.program;
    }

    return result;
  });

  // Заполняем стуктуру программы из данных объекта
  objectUsedAttribute.forEach(o => {
    if (o.attributeValueId !== undefined) {
      result.attributeValueIdByLang[o.languageId] = o.attributeValueId;

      if (result.program.length === 0) {
        o.program.forEach(p => {
          let obj = {
            guid: guid(),
            day: p.day,
            cities: [],
            description: {}
          };

          p.cities.forEach(c => {
            obj.cities.push(c);
          });

          obj.description[o.languageId] = p.description;

          result.program.push(obj);
        });
      }
    }
  });

  // Добавляем языки, если их нет на объекте
  if (result.program.length > 0) {
    let langs = languages.map(lang => lang.id);
    result.program.forEach(prg => {
      langs.forEach(lang => {
        if (prg.description[lang] === undefined) {
          prg.description[lang] = "";
        }
      });
    });
  }

  return result;
};

const getNewDayObject = (programs, languages) => {
  let result = {
    guid: guid(),
    day: _getNextDay(programs),
    cities: [],
    description: {}
  };

  languages.forEach(lang => {
    result.description[lang.id] = "";
  });

  return result;
};

const recalcProgramDays = (rows, index) => {
  let val = rows[index];

  if (val.day === undefined) {
    val.day = _getNextDay(rows);
  }

  let newIndex = ((rows, day, index) => {
    for (let i = 0; i < rows.length; i++) {
      if (index !== i && rows[i].day >= day) {
        return rows[i].day > day ? i - 1 : i;
      }
    }
    return rows.length - 1;
  })(rows, val.day, index);

  if (index !== newIndex) {
    let start = newIndex;
    let finish = index - 1;
    let delta = 1;

    if (index < newIndex) {
      start = index + 1;
      finish = newIndex;
      delta = -1;
    }

    for (let i = start; i <= finish; i++) {
      let num = rows[i].day + delta;
      if (num > 0) {
        rows[i].day = num;
      }
    }
  }

  _resortProgramList(rows);

  return rows;
};

const prepareToSave = (programs, languageId) => {
  return programs.map(p => {
    return {
      day: p.day,
      cities: p.cities,
      description: p.description[languageId]
    };
  });
};

export {
  changeDescription,
  getProgramValueData,
  changeLanguage,
  getInitState,
  getNewDayObject,
  recalcProgramDays,
  prepareToSave
};
